// test1044
(1044 && 0);
